
import { Component, computed, input, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './paginator.component.html'
})
export class PaginatorComponent {
  page = model.required<number>();
  pageSize = model.required<number>();
  total = input.required<number>();
  totalItems = input.required<number>();
  pageLengths = input<number[]>([5, 10, 25, 50, 100]); 

  totalPages = computed(() => Math.ceil(this.total() / this.pageSize()));

  onPageChange(newPage: number): void {
    if (newPage > 0 && newPage <= this.totalPages()) {
      this.page.set(newPage);
    }
  }

  onPageSizeChange(newPageSize: number): void {
    this.pageSize.set(newPageSize);
  }
}
